import { HiChatAlt2, HiHome, HiLocationMarker } from 'react-icons/hi'
import { IoIosChatboxes } from 'react-icons/io'
import { BsSuitHeartFill } from 'react-icons/bs'
import { FaFacebookF, FaInstagram, FaTiktok, FaTwitter } from 'react-icons/fa'

import Online from '../../components/online/Online'
import Social from '../../components/buttons/Social'
import Friends from '../friends/Friends'
import Video from '../videos/Video'
import './content.css'

const Content = ({data}) => {

      if(data.length === 0) return 
console.log(data)
      const {infordata, relation, social, banners, videos, friends} = data.user 
      const BANNER_DEFAULT = "https://i.postimg.cc/08xg0Jgv/banner-bg.jpg"

      return (
            <div className="content">
                  <div className="content_inner__page">
                        <div className="wrapper_banner">
                              <div className="banner_content">
                                    <img src={banners.data ? BANNER_DEFAULT : banners[0].image} alt={banners.data ? "Banner Default" : banners[0].title} />
                              </div>
                        </div>
                        <div className="container">
                              <div className="container_col">
                                    <Online data={infordata} />
                                    <div className="wrapper_user">
                                          <div className="user_heart__icon"><BsSuitHeartFill /></div>
                                          <div className="user_header">
                                                <div className="user_avatar">
                                                      <img src={infordata.avatar} alt={infordata.name} />
                                                </div>
                                                <div className="user_nav__menu">
                                                      <a href={infordata.homepage ?? "https://xat.com"} target="_blank" rel="noreferrer"><HiHome /></a>
                                                      <a href={infordata.xat_room ?? "https://xat.com"} target="_blank" rel="noreferrer"><HiChatAlt2 /></a>
                                                      <a href={infordata.forum ?? "https://forum.xat.com"} target="_blank" rel="noreferrer"><IoIosChatboxes /></a>
                                                </div>
                                          </div>
                                          <div className="user_content">
                                                <div className="user_title">
                                                      <h1>{infordata.name}</h1>
                                                      <strong>{infordata.id_xat}</strong>
                                                </div>
                                          </div>
                                          <div className="user_footer">
                                                <div className="user_footer_details">
                                                      <span>{infordata.status}</span>
                                                      <div className="user_location">
                                                            <HiLocationMarker />
                                                            <label>{infordata.location}</label>
                                                      </div>
                                                </div>
                                                <div className="user_footer__social">
                                                      <Social link={social.facebook || "https://www.facebook.com"} icon={<FaFacebookF />} />
                                                      <Social link={social.twitter || "https://www.twitter.com"} icon={<FaTwitter />} />
                                                      <Social link={social.instagram || "https://www.instagram.com"} icon={<FaInstagram />} />
                                                      <Social link={social.tiktok || "https://www.tiktok.com"} icon={<FaTiktok />} />
                                                </div>
                                          </div>
                                    </div>

                                    <div className="about_user">
                                          <p>{infordata.about}</p>
                                    </div>
                                    <div className="wrapper_friends">
                                          <Friends data={friends} />
                                    </div>
                              </div>
                              <div className="container_col">
                                    <div className="wrapper_floating">
                                          <div className="floating_icon"><BsSuitHeartFill /></div>
                                          <div className="floating_data">
                                                <h1>{relation.love_count.day_amount}</h1>
                                                <span>Days</span>
                                          </div>
                                    </div>
                                    <div className="wrapper_relation">
                                          <div className="relation_text">
                                                <h2>Love</h2>
                                                <div className="relation_about">
                                                      <p>{relation.about}</p>
                                                </div>
                                          </div>
                                          <div className="relation_data">
                                                <div className="relation_data__info">
                                                      <h2>{relation.name}</h2>
                                                      <a href={relation.me} target="_blank" rel="noreferrer">xat.me</a>
                                                </div>
                                                <div className="relation_data__avatar">
                                                      <img src={relation.avatar} alt={relation.name} />
                                                </div>
                                          </div>
                                          <div className="relation_time">
                                                <div className="relation_time__inner">
                                                      <span>{relation.love_count.time_lapse}</span>
                                                      <div className="relation_time_range"></div>
                                                </div>
                                          </div>
                                    </div>
                                    <div className="wrapper_video">
                                          <Video data={videos} />
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>
      )
}

export default Content
